import {defineStore} from 'pinia';
const tourniquetStore = defineStore('tourniquetStore', {
    state: () => {
        return {
            removeCommentData: null,
            removeCommentShow: false,
            csrfToken: null,
            user: null,
            userCanComment: null,
            recallModalShow: false,
            recallTestId: null
        }
    },
    actions: {
        setUserCommentStatus(status) {
            this.userCanComment = +status
        },
        setUser(userData) {
            this.user = JSON.parse(userData)
        },
        setCsrfToken(token) {
            this.csrfToken = token
        },
        removeComment(id) {
            fetch(`/comments/${id}/delete`, {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': this.csrfToken,
                },
            }).then(function(response) {
                return response.json();
            }).then(() => {
                if (this.removeCommentData.has_child) {
                    this.removeCommentData.deleted = true
                    this.removeCommentData.comment = 'Коментар видалено'
                } else {
                    this.clearRemoveCommentData();
                }
                this.hideRemoveModal()
            });
        },
        setRemoveCommentData(data) {
            this.removeCommentData = data;
            this.removeCommentShow = true;
        },
        clearRemoveCommentData() {
            this.removeCommentData = null
        },
        hideRemoveModal() {
            this.removeCommentShow = false
        },
        showRecallModal(id) {
            this.recallTestId = id;
            this.recallModalShow = true
        },
        hideRecallModal() {
            this.recallModalShow = false
        }
    }
})
export {tourniquetStore}
